import { Intent, Position, Toaster } from "@blueprintjs/core";

import events from "common/events";
import CalendarUtil from 'core/util/CalendarUtil';
import TokenSession from "core/util/session/TokenSession";
import StringUtil from 'core/util/StringUtil';
import UrlUtil from 'core/util/UrlUtil';
import Course, { Variant } from 'panels/catalog/entities/Course';

/** Singleton toaster instance. Create separate instances for different options. */
export const CatalogToaster = Toaster.create({
	className: "catalog-toaster",
	position: Position.TOP
});

export function launchCourse(course: Course) {
	if (course && course.launchURL) {
		window.open(course.launchURL,'launchwin');

		CatalogToaster.show({
			intent: Intent.PRIMARY,
			message: "Course launched in new tab"
		});

		return;
	}
	alert("Invalid launch configuration");
}

export function enrollInCourse(course: Course) {
	location.href = window.location.origin;
}

export function addToCalendar(course: Course, viewDetailsPagePath: string) {
	if (!course || !course.displayStartDate) {
		return; // no invite for you
	}

	const data = {
		title: course.title,
		start: new Date(course.displayStartDate),
		end: new Date(course.displayEndDate)
	};

	if (course.shortDescription) {
		data['shortDescription'] = StringUtil.sanitize(course.shortDescription);
	} else if (course.description){
		data['description'] = StringUtil.sanitize(course.description);
	}

	if (viewDetailsPagePath) {
		data['url'] = UrlUtil.getGatewayRedirectLink(viewDetailsPagePath, {
			entryId: course.id
		});
	}

	CalendarUtil.downloadICS(data);
}


export function addToCart(course: Course, variant: Variant, disableDirectBuy?: boolean, loginBeforeBuy?: boolean) {
	let unauthenticatedBuy = loginBeforeBuy && !(TokenSession.getUser() && TokenSession.getUser().getId())
  
	// if direct buy is enable redirect to the external cart
	if(!disableDirectBuy || unauthenticatedBuy) {
		window.location.href = variant.buyUrl;
		return;
	}

	// currently using the wicket session based cart to manage cart state
	// TODO convert this to use db records for persistent cart
	// TODO based on this response perform redirect for direct buy etc
	TokenSession.doWithWicketSession(() => {
		fetch(variant.buyUrl, {
			credentials: 'include', // <- this is mandatory to deal with cookies
			headers: {
				"DI-Ajax": "true"
			},
			method: "post"
		})
			.then((response) => response.text())
			.then( (data) => {
				console.log("cart updated: ", data);
				window.dispatchEvent(events.CartUpdated);

				CatalogToaster.show({
					intent: Intent.SUCCESS,
					message: "Added to cart"
				});
			});
			// allow errors to propagate up for now
			/*.catch((e) => {
				console.log(e);
			});*/

	});
}

export function addToBuy(course: Course, variant: Variant, disableDirectBuy?: boolean, loginBeforeBuy?: boolean, pageActions?: any, quantityInCart?:any) {
	let unauthenticatedBuy =
		loginBeforeBuy &&
		!(TokenSession.getUser() && TokenSession.getUser().getId());

	// if direct buy is enable redirect to the external cart
	if (!disableDirectBuy || unauthenticatedBuy) {
		window.location.href = variant.buyUrl;
		return;
	}
	pageActions.addItemsToCart([course]);
	//adding items and quantity of each item in cart
	pageActions.setQuantityInCart([
		...quantityInCart,
		{ courseId: course.id, courseQuantity: 1 },
	]);
	setTimeout(function () {
		if ([course].length) {
			window.dispatchEvent(events.CartUpdated);
			CatalogToaster.show({
				intent: Intent.SUCCESS,
				message: "Added to cart",
			});
		}
	}, 1000);
}




// WEBPACK FOOTER //
// ./src/panels/catalog/catalogActions.ts